"use client";

import { c as _c } from "react/compiler-runtime";
import { faExpand, faRotateLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline";
import React, { useState, useRef, useCallback } from "react";
import { createPortal } from "react-dom";
import useKeyPressEvent from "react-use/lib/useKeyPressEvent";
import { fullScreenSupported } from "@/helpers/Helpers";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import Link from "next/link";
import useCapacitor from "@/hooks/useCapacitor";
import { ImageScale, getScaledImageUri } from "@/helpers/image.helpers";
import { buildTooltipId } from "@/helpers/tooltip.helpers";
import { Tooltip } from "react-tooltip";
import { resolveIpfsUrlSync } from "@/components/ipfs/IPFSContext";
const tooltipProps = {
  delayShow: 250,
  place: "top" as const,
  style: {
    backgroundColor: "#37373E",
    color: "white",
    zIndex: 1002
  }
};
const modalButtonClasses = "tw-flex tw-items-center tw-justify-center tw-border-0 tw-text-iron-50 tw-bg-iron-800 desktop-hover:hover:tw-bg-iron-700 tw-rounded-full tw-size-10 tw-flex-shrink-0 tw-backdrop-blur-sm tw-transition-all tw-duration-300 tw-ease-out";
interface DropPartMarkdownImageProps {
  readonly src: string;
  readonly alt?: string;
}
const DropPartMarkdownImage: React.FC<DropPartMarkdownImageProps> = t0 => {
  const $ = _c(48);
  let props;
  let src;
  let t1;
  if ($[0] !== t0) {
    ({
      src,
      alt: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = src;
    $[3] = t1;
  } else {
    props = $[1];
    src = $[2];
    t1 = $[3];
  }
  const alt = t1 === undefined ? "Seize" : t1;
  const [isLoading, setIsLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const imgRef = useRef(null);
  let t2;
  if ($[4] !== src) {
    t2 = buildTooltipId("open-browser-markdown", src);
    $[4] = src;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const openBrowserTooltipId = t2;
  const [isZoomed, setIsZoomed] = useState(false);
  const {
    isCapacitor
  } = useCapacitor();
  let resolvedSrc;
  let t3;
  if ($[6] !== src) {
    resolvedSrc = resolveIpfsUrlSync(src);
    t3 = getScaledImageUri(resolvedSrc, ImageScale.AUTOx450);
    $[6] = src;
    $[7] = resolvedSrc;
    $[8] = t3;
  } else {
    resolvedSrc = $[7];
    t3 = $[8];
  }
  const scaledSrc = t3;
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setIsLoading(false);
    };
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const handleImageLoad = t4;
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = event => {
      event.stopPropagation();
      setIsModalOpen(true);
    };
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const handleImageClick = t5;
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = event_0 => {
      event_0?.stopPropagation();
      setIsModalOpen(false);
    };
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const handleCloseModal = t6;
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = event_1 => {
      event_1.stopPropagation();
      if (imgRef.current) {
        imgRef.current.requestFullscreen();
      }
    };
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const handleFullScreen = t7;
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => handleCloseModal();
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  useKeyPressEvent("Escape", t8);
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="tw-fixed tw-inset-0 tw-bg-black tw-bg-opacity-80 tw-pointer-events-none" />;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      disabled: true
    };
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  const t11 = !isZoomed;
  let t12;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = e_2 => setIsZoomed(e_2.state.scale > 1);
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== alt || $[18] !== isCapacitor || $[19] !== isZoomed || $[20] !== openBrowserTooltipId || $[21] !== resolvedSrc) {
    t13 = t14 => {
      const {
        resetTransform
      } = t14;
      return <div className="tw-fixed tw-inset-0 tw-z-1000 tw-overflow-hidden tw-flex tw-items-center tw-justify-center"><div className="tw-relative tw-flex tw-flex-col lg:tw-flex-row tw-max-w-[95vw] tw-max-h-[90vh]"><div role="button" className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-flex-1 tw-min-h-0 tw-min-w-0" onClick={_temp4} tabIndex={0} onKeyDown={_temp5}><TransformComponent wrapperClass="tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center" contentClass="tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center"><img src={resolvedSrc} alt={alt} style={{
                pointerEvents: "auto"
              }} className="tw-max-h-[75vh] lg:tw-max-h-[90vh] tw-max-w-full tw-object-contain" /></TransformComponent></div><div className="tw-fixed tw-top-2 tw-right-4 tw-flex tw-flex-row tw-gap-x-4 tw-z-[1001] tw-pt-[env(safe-area-inset-top,0px)] lg:tw-relative lg:tw-top-0 lg:tw-right-auto lg:tw-flex-col-reverse lg:tw-gap-x-0 lg:tw-gap-y-2 lg:tw-ml-4 lg:tw-pt-0 lg:tw-self-start">{isZoomed && <button onClick={e_5 => {
              e_5.stopPropagation();
              resetTransform();
              setIsZoomed(false);
            }} data-tooltip-id="reset-zoom-markdown" className={modalButtonClasses} aria-label="Reset"><FontAwesomeIcon icon={faRotateLeft} className="tw-size-4" /></button>}<Link href={resolvedSrc} target="_blank" rel="noopener noreferrer"><button onClick={_temp6} data-tooltip-id={openBrowserTooltipId} className={modalButtonClasses} aria-label="Open image in new tab"><ArrowTopRightOnSquareIcon className="tw-h-5 tw-w-5 tw-flex-shrink-0" /></button></Link>{fullScreenSupported() && !isCapacitor && <button onClick={handleFullScreen} data-tooltip-id="full-screen-markdown" className={modalButtonClasses} aria-label="Full screen"><FontAwesomeIcon icon={faExpand} className="tw-size-4" /></button>}<button onClick={handleCloseModal} data-tooltip-id="close-modal-markdown" className={modalButtonClasses} aria-label="Close modal"><svg className="tw-h-5 tw-w-5 tw-flex-shrink-0" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg></button></div></div></div>;
    };
    $[17] = alt;
    $[18] = isCapacitor;
    $[19] = isZoomed;
    $[20] = openBrowserTooltipId;
    $[21] = resolvedSrc;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t11 || $[24] !== t13) {
    t14 = <TransformWrapper panning={t10} limitToBounds={t11} smooth={true} onZoom={t12}>{t13}</TransformWrapper>;
    $[23] = t11;
    $[24] = t13;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== isCapacitor || $[27] !== openBrowserTooltipId) {
    t15 = !isCapacitor && <><Tooltip id={openBrowserTooltipId} {...tooltipProps}><span className="tw-text-xs">Open in Browser</span></Tooltip><Tooltip id="full-screen-markdown" {...tooltipProps}><span className="tw-text-xs">Full screen</span></Tooltip><Tooltip id="reset-zoom-markdown" {...tooltipProps}><span className="tw-text-xs">Reset zoom</span></Tooltip><Tooltip id="close-modal-markdown" {...tooltipProps}><span className="tw-text-xs">Close</span></Tooltip></>;
    $[26] = isCapacitor;
    $[27] = openBrowserTooltipId;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== t14 || $[30] !== t15) {
    t16 = <div className="tailwind-scope tw-cursor-default tw-relative tw-z-1000" onClick={handleCloseModal} onTouchStart={_temp} onTouchEnd={_temp2} onTouchMove={_temp3}>{t9}{t14}{t15}</div>;
    $[29] = t14;
    $[30] = t15;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  const modalContent = t16;
  let t17;
  if ($[32] !== isLoading) {
    t17 = isLoading && <div className="tw-absolute tw-inset-0 tw-bg-iron-800 tw-animate-pulse tw-rounded-xl tw-h-64" />;
    $[32] = isLoading;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  const t18 = `tw-object-center tw-object-contain tw-max-w-full tw-h-64 tw-cursor-pointer ${isLoading ? "tw-opacity-0" : "tw-opacity-100"}`;
  let t19;
  if ($[34] !== alt || $[35] !== props || $[36] !== scaledSrc || $[37] !== t18) {
    t19 = <img ref={imgRef} src={scaledSrc} alt={alt} onLoad={handleImageLoad} onClick={handleImageClick} className={t18} {...props} />;
    $[34] = alt;
    $[35] = props;
    $[36] = scaledSrc;
    $[37] = t18;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] !== t17 || $[40] !== t19) {
    t20 = <div className="tw-flex tw-mt-2">{t17}{t19}</div>;
    $[39] = t17;
    $[40] = t19;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  let t21;
  if ($[42] !== isModalOpen || $[43] !== modalContent) {
    t21 = isModalOpen && createPortal(modalContent, document.body);
    $[42] = isModalOpen;
    $[43] = modalContent;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  let t22;
  if ($[45] !== t20 || $[46] !== t21) {
    t22 = <>{t20}{t21}</>;
    $[45] = t20;
    $[46] = t21;
    $[47] = t22;
  } else {
    t22 = $[47];
  }
  return t22;
};
export default React.memo(DropPartMarkdownImage);
function _temp(e) {
  return e.stopPropagation();
}
function _temp2(e_0) {
  return e_0.stopPropagation();
}
function _temp3(e_1) {
  return e_1.stopPropagation();
}
function _temp4(e_3) {
  return e_3.stopPropagation();
}
function _temp5(e_4) {
  if (e_4.key === "Enter" || e_4.key === " ") {
    e_4.stopPropagation();
  }
}
function _temp6(e_6) {
  return e_6.stopPropagation();
}